module.exports = __webpack_public_path__ + "media/images/default_user-01fbfcff802638354a1aff9cd5c17012.png";